import React from 'react';
import {useTranslation} from "react-i18next";
import EmptyState from "../../../feeback/State/Empty";
import Graphic from "../../../../../resources/images/records.svg";

const Empty = () => {
    const {t} = useTranslation();
    return (
        <EmptyState
            title={t('site_album_records_empty_title')}
            textI18Key='site_album_records_empty_text'
            graphic={Graphic}
        />
    );
};

export default Empty;